import React from 'react';
import { Link } from 'react-router-dom';

const SingleService = ({icon,title,text}) => {
   return (
      <>
         <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="services__item mb-90">
               <div className="services__icon mb-10">
                  <img src={`assets/img/icon/services/services-${icon}.svg`} alt={title} width={40} height={40} />
               </div>
               <div className="services__content">
                  <h3><Link to="/services">{title}</Link></h3>
                  <p>{text}</p>
               </div>
            </div>
         </div>
      </>
   );
};

export default SingleService;